import { DDSHeadlineText } from "@web-monorepo/dds";
import { IconCheck } from "@web-monorepo/dds-icons";
import styles from "./PersonListItem.module.css";

export type Person = {
  _id: string;
  avatar: string;
  firstName: string;
};

type PersonListItemProps = {
  person: Person;
  selected?: boolean;
  toggle: (personId: string) => void;
};

export default function PersonListItem({ person, selected = true, toggle }: PersonListItemProps) {
  return (
    <button
      type="button"
      data-name="person_list_item:toggle"
      onClick={() => toggle(person._id)}
      aria-pressed={selected}
      className={styles.personListItemButton}
    >
      <div className={styles.avatarWrap}>
        <img src={person.avatar} className={styles.avatar} alt="" />
      </div>
      <div className={styles.name}>
        <DDSHeadlineText as="h2" level="md">
          {person.firstName}
        </DDSHeadlineText>
      </div>
      {selected && (
        <div className={styles.checkmarkWrap}>
          <IconCheck />
        </div>
      )}
    </button>
  );
}
